import { jsxs as o, jsx as i } from "react/jsx-runtime";
import "react";
import "dayjs";
import "react-i18next";
import "../../../contexts/global-context.js";
import "motion/react";
import "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import { Heading as m } from "../../elements/heading/heading.js";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import r from "./section-divider-block.module.less.js";
const u = ({ title: e }) => /* @__PURE__ */ o("section", { className: r.wrapper, children: [
  /* @__PURE__ */ i("div", { className: r.divider }),
  /* @__PURE__ */ i("div", { className: [r.innerWrapper, "max-width padded-sides"].join(" "), children: e && /* @__PURE__ */ i(m, { semanticType: "h2", visualType: "h2", children: e }) })
] });
export {
  u as SectionDividerBlock,
  u as default
};
